import firebase from "../constants/firebase";
import {
  USER_REGISTRATIONS,
  EMPLOYEES,
  STUDENTS,
  USER_ACCOUNTS,
  USERS,
} from "../constants/collections";
import { SCHOOL_ADMIN } from "../constants/userAccounts";

export const setUserRegistrationCompleted = async (regId) => {
  const db = firebase.firestore();
  const userRegRef = db.collection(USER_REGISTRATIONS).doc(regId);
  return await userRegRef.set(
    {
      completed: true,
      lastUpdated: firebase.firestore.FieldValue.serverTimestamp(),
    },
    { merge: true },
  );
};

export const setProfileUserRegistrationEnabled = async (
  registration,
  userId,
) => {
  const db = firebase.firestore();
  const COL = registration.profileType === "employee" ? EMPLOYEES : STUDENTS;
  const profileUserRegRef = db
    .collection(COL)
    .doc(registration.profileId)
    .collection(USER_ACCOUNTS)
    .doc(registration.role.value);
  if (registration.profileType === "employee") {
    const userRef = db.collection(USERS).doc(userId);
    const employeeRef = db.collection(EMPLOYEES).doc(registration.profileId);
    const employeeSnap = await employeeRef.get();
    let rolesToAdd = [registration.role.value];

    if (employeeSnap.exists && employeeSnap.data().pendingSchoolAdmin) {
      rolesToAdd.push(SCHOOL_ADMIN);
      await employeeRef.update({
        pendingSchoolAdmin: firebase.firestore.FieldValue.delete(),
      });
    }

    await userRef.set(
      {
        roles: firebase.firestore.FieldValue.arrayUnion(...rolesToAdd),
      },
      { merge: true },
    );
  }

  return await profileUserRegRef.set(
    {
      status: "enabled",
      uid: userId,
    },
    { merge: true },
  );
};

export const getUserAccount = async (profileId, type) => {
  const db = firebase.firestore();
  const COL = type === "employee" ? EMPLOYEES : STUDENTS;
  const profileUserRegRef = db
    .collection(COL)
    .doc(profileId)
    .collection(USER_ACCOUNTS)
    .doc(type);
  const userAcctSnap = await profileUserRegRef.get();
  return userAcctSnap.data();
};

export const makeSchoolAdmin = async (userId) => {
  const db = firebase.firestore();
  const usersRef = db.collection(USERS).doc(userId);
  return await usersRef.set(
    {
      roles: firebase.firestore.FieldValue.arrayUnion(SCHOOL_ADMIN),
    },
    { merge: true },
  );
};

export const revokeSchoolAdmin = async (userId) => {
  const db = firebase.firestore();
  const usersRef = db.collection(USERS).doc(userId);
  return await usersRef.update({
    roles: firebase.firestore.FieldValue.arrayRemove(SCHOOL_ADMIN),
  });
};

export const getEmployeeUid = async (employeeId) => {
  const db = firebase.firestore();
  const accountsRef = db
    .collection(EMPLOYEES)
    .doc(employeeId)
    .collection(USER_ACCOUNTS);
  const snapshot = await accountsRef.get();
  if (snapshot.empty) return null;

  let uid = null;
  snapshot.forEach((doc) => {
    const data = doc.data();
    if (data.status === "enabled" && data.uid) {
      uid = data.uid;
    }
  });
  return uid;
};
